import Vue from 'vue';
import Vuex from 'vuex';
import { auth } from './firebase';

Vue.use(Vuex);

// eslint-disable-next-line
export const store = new Vuex.Store({
  state: {
    user: null
  },
  getters: {
    getUser: state => state.user
  },
  mutations: {
    setUser: state => {
      // eslint-disable-next-line
      state.user = auth.currentUser;
    }
  },
  actions: {
    setUser: context => {
      context.commit('setUser');
    }
  }
});
